import { useState } from "react";
import { AREA_GROUPS } from "@/lib/areas";
import { Search } from "lucide-react";

export function CoverageLists({ carers }) {
  const [view, setView] = useState("befriender");
  const [q, setQ] = useState("");
  const term = q.trim().toLowerCase();
  const hit = (s) => s.toLowerCase().includes(term);

  const byPerson = carers
    .map((s) => ({ ...s, areas: s.work_areas || [] }))
    .filter((s) => !term || hit(s.name || "") || s.areas.some(hit))
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  const byArea = AREA_GROUPS.flatMap(([group, towns]) => towns.map((t) => ({
    town: t, group, names: carers.filter((s) => (s.work_areas || []).includes(t)).map((s) => s.name),
  }))).filter((r) => (term ? hit(r.town) || hit(r.group) || r.names.some(hit) : r.names.length > 0));

  return (
    <div className="rounded-xl border border-border bg-white p-5 shadow-sm" data-testid="coverage-lists">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-2">
          {[["befriender", "By befriender"], ["area", "By area"]].map(([k, l]) => (
            <button key={k} onClick={() => setView(k)} data-testid={`coverage-list-tab-${k}`}
              className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${view === k ? "bg-brand text-white" : "bg-secondary text-ink hover:bg-brand-light"}`}>{l}</button>
          ))}
        </div>
        <label className="flex w-full items-center gap-2 rounded-lg border border-border px-3 py-2 sm:w-72">
          <Search size={15} className="text-ink-muted" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or town…" data-testid="coverage-search" className="w-full bg-transparent text-sm outline-none" />
        </label>
      </div>

      {view === "befriender" ? (
        <div className="divide-y divide-border" data-testid="coverage-by-befriender">
          {byPerson.length === 0 && <p className="py-3 text-sm text-ink-muted">No befrienders match.</p>}
          {byPerson.map((s) => (
            <div key={s.id} className="flex flex-col gap-1 py-3 sm:flex-row sm:gap-4" data-testid={`coverage-person-${s.id}`}>
              <p className="w-48 shrink-0 font-semibold text-ink">{s.name}</p>
              <p className="text-sm text-ink-soft">{s.areas.length ? s.areas.join(", ") : <span className="italic text-ink-muted">No areas chosen yet</span>}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="divide-y divide-border" data-testid="coverage-by-area">
          {byArea.length === 0 && <p className="py-3 text-sm text-ink-muted">{term ? "No towns match." : "No befrienders have chosen areas yet."}</p>}
          {byArea.map((r) => (
            <div key={r.town} className="flex flex-col gap-1 py-3 sm:flex-row sm:gap-4" data-testid={`coverage-area-${r.town}`}>
              <p className="w-48 shrink-0"><span className="font-semibold text-ink">{r.town}</span><span className="block text-xs text-ink-muted">{r.group}</span></p>
              <p className="text-sm text-ink-soft">{r.names.length ? r.names.join(", ") : <span className="italic text-coral-dark">No befrienders cover this area</span>}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
